jQuery(document).ready(function($) {

    // BLOCKS

    // Post Feed Block
      // Load More Button - Posts from the Post Feed Block
  $(".load-more--posts").on("click", function(e){
    e.preventDefault();
    // If there are any .post-feed__ items hidden, show 3 more
    if($(".post-feed__block:hidden").length > 0) {
        $(".post-feed__block:hidden").slice(0, 3).slideDown();
    }
    if($(".post-feed__resource:hidden").length > 0) {
        $(".post-feed__resource:hidden").slice(0, 3).slideDown();
    }
    if($(".post-feed__success-story:hidden").length > 0) {
        $(".post-feed__success-story:hidden").slice(0, 3).slideDown();
    }
    // If there are no more .post-feed__ items hidden, change the button text and disable it
    if(
        $(".post-feed__block:hidden").length == 0 &&
        $(".post-feed__resource:hidden").length == 0 &&
        $(".post-feed__success-story:hidden").length == 0
    ) {
        $(".load-more--posts").text("End of content").addClass("no-content").off("click").attr("disabled", true);
    }
  });


    // Show More on Team Members Page
$(".member-show-more__button").on('click', function () {
    // Slide up any currently visible descriptions, except the one being clicked
    $('.member-show-more__description.show-description').not($(this).next()).slideUp(1000).removeClass('show-description');

    // Change text of all buttons to "Read description"
    $('.member-show-more__button').text('Read description');

    // Slide down the clicked description if it's not already visible
    var $description = $(this).next('.member-show-more__description');
    if (!$description.hasClass('show-description')) {
        $description.slideDown(500).addClass('show-description');
        $(this).text('Close description');
    } else {
        $description.slideUp(500).removeClass('show-description');
        $(this).text('Read description');
    }
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.member-show-more__description').length &&
        !$(event.target).closest('.member-show-more__button').length) {
        // Slide up any visible descriptions when clicking outside
        $('.member-show-more__description.show-description').slideUp(700).removeClass('show-description');

        // Change text of all buttons to "Read description"
        $('.member-show-more__button').text('Read description');
    }
});


// Show/Hide
	$('.show-more-content').hide();

	$('.show-more-content:has(".gform_validation_error")').show();

	$(document).on('click', '.show-more', function() {
	    var $this = $(this);
	    var $accordionGroup = $this.closest('.full-accordion-group');
	    var $accordionContent = $this.next('.show-more-content');

	    // Collapse all other accordion items within the same group
	    $accordionGroup.find('.show-more-content').not($accordionContent).slideUp(500, function() {
	        $(this).prev('.show-more').removeClass('showing');
	    });

	    // Toggle the clicked accordion item
	    $accordionContent.slideToggle(500);
	    $this.toggleClass('showing');

	    return false;
    });


   // Filters by Category
$('.filter-button').click(function () {
    var selectedCategory = $(this).data('category');

    $('.post-feed__resource, .post-feed__success-story').each(function() {
        // Get the category associated with this post
        var postCategory = $(this).data('category');

        if (selectedCategory === '' || postCategory === selectedCategory) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    if ($('.post-feed__resource:visible, .post-feed__success-story:visible').length === 0) {
        $('#map-no-results').show();
    } else {
        $('#map-no-results').hide();
    }
});

$('.form-check').click(function () {
    $('.form-check').removeClass('active');
    $(this).addClass('active');
});


// Filter by keyword
$('#keyword-filter').click(function () {
    var keyword = $('#keyword-input').val().toLowerCase();

    $('.post-feed__resource, .post-feed__success-story').each(function() {
        var postContent = $(this).text().toLowerCase();
        if (postContent.includes(keyword) || keyword === '') {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    if ($('.post-feed__resource:visible, .post-feed__success-story:visible').length === 0) {
        $('#map-no-results').show();
    } else {
        $('#map-no-results').hide();
    }
});

// Filter by Tag
$('#tag').change(function() {
    var selectedTag = $(this).val();

    $('.post-feed__resource, .post-feed__success-story').each(function() {
        var tags = $(this).data('tag').split(' ');
        if (selectedTag === '' || tags.includes(selectedTag)) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    if ($('.post-feed__resource:visible, .post-feed__success-story:visible').length === 0) {
        $('#map-no-results').show();
    } else {
        $('#map-no-results').hide();
    }
});


    // Event handler for tag selection
    $('#tag').on('change', function() {
        var selectedTag = $(this).val();
        filterPostsByTag(selectedTag);
    });

    // Reset All Filters
    $('#reset-button').click(function () {
        // Reset Category Filter (radio buttons)
        $('input[name="category"]').prop('checked', false);
        $('#category-all').prop('checked', true);

        // Remove active class from all category buttons
        $('.form-check').removeClass('active');
        $('#category-all').closest('.form-check').addClass('active');
        // Reset Tag Filter (dropdown)
        $('#tag').val('');

        // Reset Keyword Filter (input field)
        $('#keyword-input').val('');

        // Show all posts after resetting filters
        $('.post-feed__resource, .post-feed__success-story').show();

        // Hide "No results" message
        $('#map-no-results').hide();
      });

      // Reset for Locations
      $('#reset-button').click(function () {
        // Reset Category Filter (radio buttons)
        $('input[name="category"]').prop('checked', false);

        $('#category-all').prop('checked', true);

        // Remove active class from all category buttons
        $('.form-check').removeClass('active');
        $('#category-all').closest('.form-check').addClass('active');

        // Reset State Filter (dropdown)
        $('#state').val('');

        // Reset Zip Code Filter (input field)
        $('#zipcode-input').val('');

        // Show all locations after resetting filters
        $('#locations-results .location-item').show();

        // Hide "No results" message
        $('#map-no-results').hide();

        // Refresh the page to reload all locations
        location.reload();
      });

      // Search in Mobile
      $('.navigation-utility .search i').click(function () {
        if ($('.search').hasClass('active')) {
          $('.search').removeClass('active');
        } else {
          $('.search').addClass('active');
        }
      });

      // Gravity Forms success message

      // Function to scroll to the confirmation wrapper
      function scrollToConfirmationWrapper() {
        var confirmationWrapper = $('[id^="gform_confirmation_wrapper_"]');
        if (confirmationWrapper.length) {
          $('html, body').animate({
            scrollTop: confirmationWrapper.offset().top
          }, 1000);
        }
      }

      // For AJAX-enabled forms
      $(document).on('gform_confirmation_loaded', function (event, formId) {
        scrollToConfirmationWrapper();
      });

      // For non-AJAX forms, using a delay to wait for the confirmation wrapper to appear
      $(document).on('gform_post_render', function (event, formId) {
        setTimeout(scrollToConfirmationWrapper, 200);
      });


});

// Responsive Menu:
document.addEventListener('DOMContentLoaded', function () {
    // Getting main menu elements
    const menuContainer = document.querySelector('.menu-container');
    const menuToggle = menuContainer.querySelector('.menu-button');
    const siteHeaderMenu = menuContainer.querySelector('#site-header-menu');
    const siteNavigation = menuContainer.querySelector('#site-navigation');

    // Function to check if the screen is mobile
    function isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
    }

    // If the menu toggle button exists, set up its behaviors
    if (menuToggle) {
        // Initial ARIA attribute setup for accessibility
        menuToggle.setAttribute('aria-expanded', 'false');
        siteNavigation.setAttribute('aria-expanded', 'false');

        // Event listener for main menu toggle button
        menuToggle.addEventListener('click', function () {
            // Toggle visual states for the button and menu
            this.classList.toggle('toggled-on');
            siteHeaderMenu.classList.toggle('toggled-on');

            // Determine and set the new expanded state for ARIA
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const newExpandedState = isExpanded ? 'false' : 'true';

            // Update ARIA attributes
            this.setAttribute('aria-expanded', newExpandedState);
            siteNavigation.setAttribute('aria-expanded', newExpandedState);
        });
    }

    // Set up dropdown toggle buttons for menu items with children
    const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children > .dropdown-toggle');
    menuItemsWithChildren.forEach(function (item) {
        const linkText = item.textContent;

        // Create the dropdown toggle button
        const dropdownToggle = document.createElement('button');
        dropdownToggle.className = 'dropdown-toggle';
        dropdownToggle.setAttribute('aria-expanded', 'false');

        // Set ARIA label for accessibility
        dropdownToggle.setAttribute('aria-label', linkText + ' submenu');

        // Insert the dropdown button after the menu item
        item.insertAdjacentElement('afterend', dropdownToggle);

        // Set up behavior when the dropdown button is clicked
        dropdownToggle.addEventListener('click', function () {
            // Determine the expanded state of the dropdown
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
        });

        // Set up behavior when the menu item link is clicked on mobile
        item.addEventListener('click', function (e) {
            if (isMobile()) {
                e.preventDefault();
                dropdownToggle.click();
            }
        });
    });

    // Toggle dropdowns behavior
    const dropdownToggles = siteHeaderMenu.querySelectorAll('.dropdown-toggle');
    dropdownToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent event from bubbling

            // Toggle the clicked dropdown
            this.classList.toggle('toggled-on');
            const nextSubMenu = this.nextElementSibling;
            if (nextSubMenu && nextSubMenu.classList.contains('sub-menu')) {
                nextSubMenu.classList.toggle('toggled-on');
            }

            // Update the ARIA expanded state of the dropdown
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);

            // Close other dropdowns on the same level to avoid multiple open dropdowns
            const siblingToggles = Array.from(this.parentElement.parentElement.children)
                .map((el) => el.querySelector('.dropdown-toggle'))
                .filter((el) => el !== null && el !== this);

            siblingToggles.forEach((sibToggle) => {
                sibToggle.classList.remove('toggled-on');
                const sibSubMenu = sibToggle.nextElementSibling;
                if (sibSubMenu && sibSubMenu.classList.contains('sub-menu')) {
                    sibSubMenu.classList.remove('toggled-on');
                }
                sibToggle.setAttribute('aria-expanded', 'false');
            });
        });
    });

    // Indicate that a menu has a sub-menu
    const subMenus = document.querySelectorAll('.sub-menu .menu-item-has-children');
    subMenus.forEach(function (subMenu) {
        subMenu.parentElement.classList.add('has-sub-menu');
    });

    // Check if dropdown selectors are present before setting up dropdown auto select
    const dropdownSelectors = document.querySelectorAll('.dropdown-selector');
    if (dropdownSelectors.length > 0) {
        // Add logic for dropdown auto select here
        // Assuming you have some logic to handle dropdown auto select
        dropdownSelectors.forEach((selector) => {
            // Your dropdown auto select logic
        });
    }

    // Keyboard navigation setup for menu
    const menuLinksAndDropdownToggles = document.querySelectorAll('.menu-item a, button.dropdown-toggle');
    menuLinksAndDropdownToggles.forEach(function (element) {
        element.addEventListener('keydown', function (e) {
            const key = e.keyCode;

            // Key handling for improved keyboard navigation
            if (![27, 37, 38, 39, 40].includes(key)) {
                return;
            }

            // Handle different keys for navigation
            switch (key) {
                case 27: // Escape: Close dropdown or main menu
                    e.preventDefault();
                    e.stopPropagation();
                    const parentDropdown = this.closest('ul').previousElementSibling;
                    if (parentDropdown && parentDropdown.classList.contains('dropdown-toggle') && parentDropdown.classList.contains('toggled-on')) {
                        parentDropdown.focus();
                        parentDropdown.click();
                    } else if (!parentDropdown) {
                        // If no parent dropdown found, close the main menu.
                        if (menuToggle && menuToggle.classList.contains('toggled-on')) {
                            menuToggle.click();
                            menuToggle.focus();
                        }
                    }
                    break;

                case 37: // Left arrow: Move focus to the previous item
                    e.preventDefault();
                    if (this.classList.contains('dropdown-toggle')) {
                        this.previousElementSibling.focus();
                    } else {
                        const prevSibling = this.parentElement.previousElementSibling;
                        if (prevSibling && prevSibling.querySelector('button.dropdown-toggle')) {
                            prevSibling.querySelector('button.dropdown-toggle').focus();
                        } else if (prevSibling && prevSibling.querySelector('a')) {
                            prevSibling.querySelector('a').focus();
                        }
                    }
                    break;

                case 39: // Right arrow: Move focus to the next item or enter a submenu
                    e.preventDefault();
                    if (this.nextElementSibling && this.nextElementSibling.matches('button.dropdown-toggle')) {
                        this.nextElementSibling.focus();
                    } else {
                        const nextSibling = this.parentElement.nextElementSibling;
                        if (nextSibling) {
                            nextSibling.querySelector('a').focus();
                        }
                    }
                    if (this.matches('ul.sub-menu .dropdown-toggle.toggled-on')) {
                        this.parentElement.querySelector('ul.sub-menu li:first-child a').focus();
                    }
                    break;

                case 40: // Down arrow: Move focus to the next item or submenu
                    e.preventDefault();
                    if (this.nextElementSibling) {
                        const firstChildLink = this.nextElementSibling.querySelector('li:first-child a');
                        if (firstChildLink) {
                            firstChildLink.focus();
                        }
                    } else {
                        const nextElem = this.parentElement.nextElementSibling;
                        if (nextElem) {
                            nextElem.querySelector('a').focus();
                        }
                    }
                    break;

                case 38: // Up arrow: Move focus to the previous item or exit a submenu
                    e.preventDefault();
                    const prevElem = this.parentElement.previousElementSibling;
                    if (prevElem) {
                        prevElem.querySelector('a').focus();
                    } else {
                        const closestUl = this.closest('ul');
                        if (closestUl && closestUl.previousElementSibling.matches('.dropdown-toggle.toggled-on')) {
                            closestUl.previousElementSibling.focus();
                        }
                    }
                    break;
            }
        });
    });
});



jQuery(document).ready(function($) {
    // Check if Masonry is available
    if ($.fn.masonry) {
        var $grid = $('.image-grid');
        var $masonryContainer = $('<div class="masonry-container"></div>');

        // Move grid items to the masonry container
        $grid.children().appendTo($masonryContainer);
        $grid.append($masonryContainer);

        function applyMasonryOptions() {
            var isMobile = $(window).width() <= 992;

            // Update masonry container height on mobile
            if (isMobile) {
                $masonryContainer.css('height', '100vh'); // Full viewport height
            } else {
                $masonryContainer.css('height', 'auto');
            }

            // Check if Masonry is initialized
            if ($masonryContainer.data('masonry')) {
                $masonryContainer.masonry('destroy'); // Destroy previous Masonry instance
            }

            // Initialize Masonry
            $masonryContainer.masonry({
                itemSelector: '.grid-item',
                percentPosition: true,
                columnWidth: '.grid-item',
                horizontalOrder: true,
                originTop: true // Always set originTop to true
            });

            hideExtraImages(); // Call the function to hide extra images
        }

        function hideExtraImages() {
            if ($(window).width() <= 992) {
                $('.grid-item:gt(3)').hide(); // Hide all but the first 4 images on mobile
            } else {
                $('.grid-item').show(); // Show all images on larger screens
            }
            if ($masonryContainer.data('masonry')) {
                $masonryContainer.masonry('layout'); // Trigger Masonry layout after hiding/showing images
            }
        }

        // Initialize Masonry after all images have loaded
        $masonryContainer.imagesLoaded(function() {
            applyMasonryOptions(); // Call the function on initial load
        });

        // Bind the function to the window resize event
        $(window).resize(function() {
            applyMasonryOptions();
        });

        // Trigger initial resize to ensure layout is applied correctly on load
        $(window).trigger('resize');
    } else {
        console.warn('Masonry is not loaded on this page.');
    }
});


var header = document.getElementById("wrapper-navbar");

window.onscroll = function() {
    var rect = header.getBoundingClientRect();
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    // Adjust scroll position by header height
    if (scrollTop > rect.height) {
        if (!header.classList.contains("shrink")) {
            header.classList.add("shrink");
            header.classList.remove("normal");
        }
    } else {
        if (!header.classList.contains("normal")) {
            header.classList.remove("shrink");
            header.classList.add("normal");
        }
    }
};


document.addEventListener("DOMContentLoaded", function() {
    var curvebgTopElements = document.querySelectorAll('.curvebg-top');
    curvebgTopElements.forEach(function(element) {
        var previousSibling = element.previousElementSibling;
        if (previousSibling && previousSibling.classList.contains('alignfull')) {
            previousSibling.classList.add('before-curvebg-top');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.menu-item-has-children');

    menuItems.forEach((menuItem) => {
        const subMenu = menuItem.querySelector('.sub-menu');

        menuItem.addEventListener('focusin', () => {
            if (subMenu) {
                subMenu.style.visibility = 'visible';
                subMenu.style.opacity = '1';
            }
        });
        menuItem.addEventListener('focusout', (e) => {

            if (!menuItem.contains(e.relatedTarget)) {
                if (subMenu) {
                    subMenu.style.visibility = 'hidden';
                    subMenu.style.opacity = '0';
                }
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll(".show-more");
    accordions.forEach((accordion) => {let isTabbing = false;
        let isMouseDown = false;

        accordion.addEventListener("focus", function () {
            if (!isMouseDown) {
                isTabbing = true;
                // this.click();
            }
        });

        accordion.addEventListener("focusout", function () {
            if (isTabbing) {
                isTabbing = false;
            }
        });
        accordion.addEventListener("mousedown", function () {
            isMouseDown = true;
        });

        accordion.addEventListener("mouseup", function () {
            isMouseDown = false;
        });

        // Add keydown event listener for keyboard navigation
        accordion.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                this.click();
            }
        });
    });
});